import { Box } from "@components/Box/Box";
import { Container } from "@components/Container/Container";
import { Icon } from "@components/Icon/Icon";
import { Link } from "@components/Link/Link";
import React from "react";
import styles from "./styles.module.scss";
import facebookIcon from "@svg-icons/facebook.component.svg";
import linkedinIcon from "@svg-icons/linkedin.component.svg";
import twitterIcon from "@svg-icons/twitter.component.svg";
import youtubeIcon from "@svg-icons/youtube.component.svg";
import instagramIcon from "@svg-icons/instagram.component.svg";

export interface FooterProps {
  address: string;
}

const UVMFooter: React.FC<FooterProps> = ({ address }) => (
  <Box as="footer" className={styles.footer}>
    <Container className={styles.footerBottom}>
      <Box
        className={styles.footerAddress}
        dangerouslySetInnerHTML={{ __html: address }}
      ></Box>
      <Box as="ul" className={styles.footerSocial}>
        <Box as="li">Følg Sikker Trafik</Box>
        <Box as="li">
          <Link
            href="https://www.facebook.com/sikkertrafik"
            title="Facebook"
            target="_blank"
            className="facebook"
          >
            <Icon svg={facebookIcon} />
          </Link>
        </Box>
        <Box as="li">
          <Link
            href="https://www.linkedin.com/company/raadet-for-sikker-trafik"
            title="Linkedin"
            target="_blank"
            className="linkedin"
          >
            <Icon svg={linkedinIcon} />
          </Link>
        </Box>
        <Box as="li">
          <Link
            href="https://twitter.com/sikkertrafik"
            title="Twitter"
            target="_blank"
            className="twitter"
          >
            <Icon svg={twitterIcon} />
          </Link>
        </Box>
        <Box as="li">
          <Link
            href="https://www.youtube.com/user/Sikkertrafik"
            title="YouTube"
            target="_blank"
            className="youtube"
          >
            <Icon svg={youtubeIcon} />
          </Link>
        </Box>
        <Box as="li">
          <Link
            href="https://www.instagram.com/raadet_for_sikker_trafik/"
            title="Instagram"
            target="_blank"
            className="instagram"
          >
            <Icon svg={instagramIcon} />
          </Link>
        </Box>
      </Box>
    </Container>
  </Box>
);
export { UVMFooter };
